<template>
  <SmallCtaButton class="--dark-blue" v-bind="$props" />
</template>

<script>
export default {
  props: {
    text: String,
    action: String,
  },
}
</script>
